export default{
    user: null,
    globales: [],
    date: null,
    showMenu: true,
    isLogged: false,
    error: false,
    errorMessage: '',
    access_token: '',
    token_device: ''

}